import {Grid, Typography, useReachGoalCallback} from '@logistics-frontend/blocks'
import React, {useCallback} from 'react'

import {PromoBannerButton, useDownloadAppCallback} from '../promo-banner-button'
import {PromoBannerPopupScreen} from '../promo-banner-popup-screen'
import {BannerView, METRIKA_GOALS} from '../PromoBanner.consts'
import {usePromoBannerContext} from '../PromoBanner.context'
import {classes} from './PromoBannerWithLeadButton.classes'
import {Props} from './PromoBannerWithLeadButton.types'

const Base: React.FC<Props> = ({title, subtitle, trail_button, lead_button}) => {
  const {isPopupScreenVisible} = usePromoBannerContext()
  const promoCode = lead_button?.action === 'copy-coupon' ? lead_button.text : undefined

  const reachGoalCallback = useReachGoalCallback()
  const getApplicationCallback = useDownloadAppCallback(BannerView.WITH_LEAD_BUTTON, promoCode)

  const onClick = useCallback(() => {
    reachGoalCallback(METRIKA_GOALS.INSTALL_BANNER_WITH_PROMO_INSTALL_CLICK)
    getApplicationCallback()
  }, [getApplicationCallback, reachGoalCallback])

  return (
    <>
      <div className={classes.root} onClick={onClick}>
        <Grid alignItems="flex-start" direction="column" size="s" container>
          <Grid direction="column" container item>
            <Grid item>
              <Typography className={classes.text} group="normal" thickness="bold" variant="body2">
                {title}
              </Typography>
            </Grid>
            <Grid item>
              <Typography className={classes.text} variant="caption1">
                {subtitle}
              </Typography>
            </Grid>
          </Grid>
          <Grid alignItems="flex-start" size="s" wrap="nowrap" container item zeroMinWidth>
            <Grid xs={6} item>
              <PromoBannerButton {...lead_button} bannerView={BannerView.WITH_LEAD_BUTTON} promoCode={promoCode} />
            </Grid>
            <Grid xs={6} item>
              <PromoBannerButton {...trail_button} bannerView={BannerView.WITH_LEAD_BUTTON} promoCode={promoCode} />
            </Grid>
          </Grid>
        </Grid>
      </div>
      <PromoBannerPopupScreen {...lead_button.popup_screen} isOpen={isPopupScreenVisible} promoCode={promoCode} />
    </>
  )
}

export const PromoBannerWithLeadButton = React.memo(Base)
